import { AmacUrl, Page } from 'src/common/routes';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import useToken from 'src/common/useToken';
import moment from 'moment';
import { setGlobalState, useGlobalState } from 'src/state/globalstate';

export default function ProtectedRoute(props) {
  return props.children;
}

export function SessionMaintained(props) {
  return props.children;
}
